import { render, staticRenderFns } from "./purchaseCategory.vue?vue&type=template&id=024a40f0&"
import script from "./purchaseCategory.vue?vue&type=script&lang=js&"
export * from "./purchaseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports